module.exports = __webpack_public_path__ + "img/shield-icon.31b9265.svg";